/* Elite Sport Colombia · interacciones del diseño internacional (elitesport.soccer), adaptadas a secciones Shopify. */
(function () {
  'use strict';

  var revealObs = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); revealObs.unobserve(e.target); } });
  }, { threshold: 0.12 }) : null;

  function initReveal(root) {
    root.querySelectorAll('.reveal:not(.in)').forEach(function (el) {
      if (revealObs) revealObs.observe(el); else el.classList.add('in');
    });
  }

  /* Encabezado: sombra al hacer scroll + menú móvil */
  function initHeader(root) {
    var nav = root.querySelector('#nav');
    if (nav && !nav.dataset.esInit) {
      nav.dataset.esInit = '1';
      /* Horizon hace scroll dentro de .page-wrapper en escritorio, no en window */
      var pw = document.querySelector('.page-wrapper');
      var onScroll = function () { nav.classList.toggle('scrolled', Math.max(window.scrollY, pw ? pw.scrollTop : 0) > 60); };
      window.addEventListener('scroll', onScroll, { passive: true });
      if (pw) pw.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    var mob = root.querySelector('#mobNav'), ham = root.querySelector('#hamburger'), close = root.querySelector('#mobClose');
    if (mob && ham && !ham.dataset.esInit) {
      ham.dataset.esInit = '1';
      ham.addEventListener('click', function () { mob.classList.add('open'); mob.setAttribute('aria-hidden', 'false'); });
      if (close) close.addEventListener('click', function () { mob.classList.remove('open'); mob.setAttribute('aria-hidden', 'true'); });
      mob.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { mob.classList.remove('open'); }); });
    }
  }

  /* Hero: rotación de anillos */
  function initHero(root) {
    root.querySelectorAll('[data-es-hero]').forEach(function (hero) {
      if (hero.dataset.esInit) return; hero.dataset.esInit = '1';
      var vid = hero.querySelector('video.hero-video');
      if (vid) { vid.muted = true; var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {}); }
      var slides = hero.querySelectorAll('.hero-slide'), dots = hero.querySelectorAll('.hero-dot'), cnt = hero.querySelector('[data-es-count]'), cur = 0;
      if (slides.length < 2) return;
      function goTo(n) {
        slides[cur].classList.remove('active'); if (dots[cur]) dots[cur].classList.remove('active');
        cur = (n + slides.length) % slides.length;
        slides[cur].classList.add('active'); if (dots[cur]) dots[cur].classList.add('active');
        if (cnt) cnt.textContent = String(cur + 1).padStart(2, '0');
      }
      dots.forEach(function (d) { d.addEventListener('click', function () { goTo(+d.dataset.idx); }); });
      hero._esTimer = setInterval(function () { goTo(cur + 1); }, 5000);
    });
  }

  /* Guante destacado: entrada + inclinación 3D */
  function initGlove(root) {
    root.querySelectorAll('[data-es-glove]').forEach(function (container) {
      if (container.dataset.esInit) return; container.dataset.esInit = '1';
      var wrap = container.querySelector('.col-img-wrap'); if (!wrap) return;
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          if (es[0].isIntersecting) { wrap.classList.add('glove-in'); container.classList.add('glove-entered'); io.disconnect(); }
        }, { threshold: 0.25 });
        io.observe(container);
      } else { wrap.classList.add('glove-in'); container.classList.add('glove-entered'); }
      container.addEventListener('mousemove', function (e) {
        var r = container.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width - 0.5) * 22, y = -((e.clientY - r.top) / r.height - 0.5) * 18;
        wrap.style.transform = 'rotateY(' + x + 'deg) rotateX(' + y + 'deg) scale(1.04)';
        wrap.style.animationPlayState = 'paused';
      });
      container.addEventListener('mouseleave', function () { wrap.style.transform = ''; wrap.style.animationPlayState = 'running'; });
    });
  }

  /* Series: pestañas, arrastre y flechas */
  function initSeries(root) {
    root.querySelectorAll('[data-es-series]').forEach(function (sec) {
      if (sec.dataset.esInit) return; sec.dataset.esInit = '1';
      var prev = sec.querySelector('[data-es-prev]'), next = sec.querySelector('[data-es-next]');
      function active() { var p = sec.querySelector('.panel.active'); return p ? p.querySelector('.carousel') : null; }
      function step() { var c = active(); if (!c) return 300; var card = c.querySelector('.pcard'); var w = card ? card.getBoundingClientRect().width + 24 : c.clientWidth * 0.8; return Math.max(w * 2, 260); }
      function place() {
        var c = active(); if (!c || !prev || !next) return;
        var img = c.querySelector('.pcard-img'); var h = img ? img.getBoundingClientRect().height : c.clientHeight;
        var t = c.offsetTop + h / 2; prev.style.top = t + 'px'; next.style.top = t + 'px';
      }
      if (prev) prev.addEventListener('click', function () { var c = active(); if (c) c.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { var c = active(); if (c) c.scrollBy({ left: step(), behavior: 'smooth' }); });
      sec.querySelectorAll('.tab').forEach(function (t) {
        function pick() {
          sec.querySelectorAll('.tab').forEach(function (x) { x.classList.remove('active'); });
          sec.querySelectorAll('.panel').forEach(function (x) { x.classList.remove('active'); });
          t.classList.add('active');
          var p = sec.querySelector('.panel[data-panel="' + t.dataset.p + '"]'); if (p) p.classList.add('active');
          setTimeout(place, 80);
        }
        t.addEventListener('click', pick);
        t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
      });
      sec.querySelectorAll('[data-drag]').forEach(function (el) {
        var d = false, moved = false, sx = 0, sl = 0;
        el.addEventListener('mousedown', function (e) { d = true; moved = false; el.style.cursor = 'grabbing'; sx = e.pageX - el.offsetLeft; sl = el.scrollLeft; });
        ['mouseleave', 'mouseup'].forEach(function (ev) { el.addEventListener(ev, function () { d = false; el.style.cursor = 'grab'; }); });
        el.addEventListener('mousemove', function (e) { if (!d) return; e.preventDefault(); var dx = e.pageX - el.offsetLeft - sx; if (Math.abs(dx) > 5) moved = true; el.scrollLeft = sl - dx * 1.5; });
        el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);
      });
      window.addEventListener('load', place); window.addEventListener('resize', place);
      setTimeout(place, 300); setTimeout(place, 900);
    });
  }

  /* Contadores animados */
  var counterObs = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { animate(e.target); counterObs.unobserve(e.target); } });
  }, { threshold: 0.5 }) : null;
  function animate(el) {
    var target = parseFloat(el.dataset.target); if (isNaN(target)) return;
    var isMillion = el.dataset.format === 'millions', duration = isMillion ? 2200 : 1800, start = null;
    function stepFn(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / duration, 1), v = (1 - Math.pow(1 - p, 3)) * target;
      el.textContent = isMillion ? Math.floor(v).toLocaleString('es-CO') : Math.floor(v);
      if (p < 1) requestAnimationFrame(stepFn); else el.textContent = isMillion ? target.toLocaleString('es-CO') : target;
    }
    requestAnimationFrame(stepFn);
  }
  function initCounters(root) {
    root.querySelectorAll('.js-counter:not([data-es-c])').forEach(function (el) { el.dataset.esC = '1'; if (counterObs) counterObs.observe(el); });
  }

  /* Mapa mundial (d3 + topojson, igual que la web internacional) */
  var HL = [32, 68, 152, 170, 188, 218, 484, 604, 858, 840, 40, 56, 100, 191, 250, 276, 300, 380, 528, 616, 620, 643, 724, 752, 756, 792, 804, 156, 376, 392, 704];
  var DOTS = [[-38.4, -63.6], [-16.3, -63.6], [-35.7, -71.5], [4.6, -74.1], [9.7, -83.8], [-1.8, -78.2], [23.6, -102.6], [-9.2, -75.0], [-32.5, -55.8], [37.1, -95.7], [47.5, 14.6], [50.8, 4.3], [42.7, 25.5], [45.1, 15.2], [46.8, 2.3], [51.2, 10.5], [39.1, 21.8], [41.9, 12.5], [52.1, 5.3], [52.1, 19.4], [39.5, -8.0], [55.8, 37.6], [40.4, -3.7], [62.0, 15.0], [46.8, 8.2], [38.9, 35.2], [48.4, 31.2], [35.9, 104.2], [31.0, 34.8], [36.2, 138.3], [14.1, 108.3]];
  var worldData = null;
  function initMap(root) {
    root.querySelectorAll('[data-es-map]').forEach(function (wrap) {
      var svg = wrap.querySelector('[data-es-map-svg]'); if (!svg) return;
      function build() {
        if (typeof d3 === 'undefined' || typeof topojson === 'undefined') return false;
        wrap.querySelectorAll('.wdot').forEach(function (d) { d.remove(); }); svg.innerHTML = '';
        var W = wrap.clientWidth || 1000, H = Math.round(W / 2);
        svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H); svg.setAttribute('width', W); svg.setAttribute('height', H);
        var proj = d3.geoNaturalEarth1().fitSize([W, H], { type: 'Sphere' }), path = d3.geoPath().projection(proj);
        var ns = 'http://www.w3.org/2000/svg';
        var g = document.createElementNS(ns, 'path'); g.setAttribute('d', path(d3.geoGraticule()())); g.setAttribute('fill', 'none'); g.setAttribute('stroke', 'rgba(197,162,120,0.04)'); g.setAttribute('stroke-width', '0.5'); svg.appendChild(g);
        function draw(world) {
          topojson.feature(world, world.objects.countries).features.forEach(function (f) {
            var p = document.createElementNS(ns, 'path'), hl = HL.indexOf(+f.id) > -1;
            p.setAttribute('d', path(f)); p.setAttribute('fill', hl ? 'rgba(197,162,120,0.28)' : 'rgba(197,162,120,0.06)');
            p.setAttribute('stroke', 'rgba(197,162,120,0.18)'); p.setAttribute('stroke-width', '0.5'); if (hl) p.setAttribute('class', 'map-country-hl');
            svg.appendChild(p);
          });
          DOTS.forEach(function (c, i) {
            var px = proj([c[1], c[0]]); if (!px) return;
            var el = document.createElement('div'); el.className = 'wdot';
            el.style.cssText = 'top:' + px[1] + 'px;left:' + px[0] + 'px;animation-delay:' + (i * 0.22) + 's;position:absolute';
            wrap.appendChild(el);
          });
        }
        if (worldData) draw(worldData);
        else fetch('https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json').then(function (r) { return r.json(); }).then(function (w) { worldData = w; draw(w); }).catch(function () {});
        return true;
      }
      if (!build()) window.addEventListener('load', build);
      if (!wrap.dataset.esInit) { wrap.dataset.esInit = '1'; var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(build, 200); }); }
    });
  }

  /* Carrito: el ícono abre el cajón de Horizon (si está activo) y el contador se actualiza al agregar */
  function setCartCount(n) {
    n = Number(n) || 0;
    document.querySelectorAll('[data-es-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
    document.querySelectorAll('[data-es-cart-num]').forEach(function (el) { el.textContent = n; });
  }
  function refreshCartCount() {
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { setCartCount(c.item_count); }).catch(function () {});
  }
  var cartInit = false;
  function initCart() {
    if (cartInit) return; cartInit = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-es-cart]'); if (!a) return;
      var drawer = document.getElementById('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        e.preventDefault();
        var mob = document.getElementById('mobNav'); if (mob) mob.classList.remove('open');
        drawer.open();
      }
    });
    document.addEventListener('shopify:cart:lines-update', function (e) {
      if (e.promise && e.promise.then) {
        e.promise.then(function (res) {
          var n = res && res.cart && res.cart.totalQuantity != null ? res.cart.totalQuantity : (res && res.detail && res.detail.itemCount);
          if (n != null) setCartCount(n); else refreshCartCount();
        }).catch(function () { refreshCartCount(); });
      } else { setTimeout(refreshCartCount, 600); }
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCartCount(); });
  }

  function initAll(root) {
    root = root || document;
    initCart();
    initHeader(document); initReveal(root); initHero(root); initGlove(root); initSeries(root); initCounters(root); initMap(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);

  /* Editor de temas */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var h = e.target.querySelector('[data-es-hero]'); if (h && h._esTimer) clearInterval(h._esTimer);
  });
})();
